/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Attack_LabelInputs */



/**
* | output |
* | --- |
* | "Attack" |
*
* @param {Audio_Description_Export_Automix_Attack_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_attack_label = /** @type {((inputs?: Audio_Description_Export_Automix_Attack_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Attack_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attaque")
	if (locale === "de") return /** @type {LocalizedString} */ ("Angriff")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attacco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Атака")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ataque")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("攻击")
	if (locale === "ja") return /** @type {LocalizedString} */ ("攻撃")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आक्रमण करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ataque")
	return /** @type {LocalizedString} */ ("Attack")
});